<div class="bid-breadcrumbs">
  <a class="bid-list-link" routerLink="/bids">All Bids</a>
  <ng-content></ng-content>
</div>
